import { render, staticRenderFns } from "./NewFansCompetitive.vue?vue&type=template&id=3730ec55&"
import script from "./NewFansCompetitive.vue?vue&type=script&lang=js&"
export * from "./NewFansCompetitive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports